import { VideoController } from "./VideoController";
export default VideoController;